import iconDownload from "../assets/flowbite_download-solid.svg";
import iconWorld from "../assets/clarity_world-solid.svg";
import iconHeart from "../assets/si_heart-fill.svg";
import iconGroup from "../assets/mingcute_group-3-fill.svg";
import logo1 from "../assets/Thetimes.png";
import logo2 from "../assets/Thetimes2.png";
import logo3 from "../assets/Thetimes3.png";
import logo4 from "../assets/Thetimes4.png";
import logo5 from "../assets/Thetimes5.png";
import logo6 from "../assets/Thetimes6.png";
import logo7 from "../assets/Thetimes7.png";
import logo8 from "../assets/Thetimes8.png";

const newsLogos = [
  { src: logo1, alt: "US National Times", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo2, alt: "News outlet 2", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo3, alt: "News outlet 3", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo4, alt: "AP", size: "h-[52px] lg:h-[68px] xl:h-[80px]" },
  { src: logo5, alt: "News outlet 5", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo6, alt: "News outlet 6", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo7, alt: "News outlet 7", size: "h-[36px] lg:h-[48px] xl:h-[56px]" },
  { src: logo8, alt: "Google News", size: "h-[44px] lg:h-[56px] xl:h-[68px]" },
];

const SocialProofSection = () => {
  return (
    <>
      <section id="as-seen-on" className="bg-white border-t border-[#EAEAEA] overflow-hidden">
        <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32">
          <h2 className="text-center font-serif text-[clamp(28px,4vw,44px)] md:text-[clamp(36px,5vw,52px)] leading-[1.2] font-medium text-[#111]">
            Luupli is everywhere in the news
          </h2>

          {/* Desktop: static grid */}
          <div className="hidden md:grid grid-cols-4 gap-8 lg:gap-10 xl:gap-12 mt-10 md:mt-14 lg:mt-16 items-center justify-items-center">
            {newsLogos.map((logo, i) => (
              <img
                key={i}
                src={logo.src}
                alt={logo.alt}
                className={`${logo.size} w-auto object-contain`}
              />
            ))}
          </div>
        </div>

        {/* Mobile: horizontal scroll animation */}
        <div className="md:hidden mt-8 mb-16 relative">
          <div className="flex gap-10 w-max animate-scroll-left items-center">
            {[...newsLogos, ...newsLogos].map((logo, i) => {
              const isLarge = logo.alt === "AP" || logo.alt === "Google News";
              return (
                <img
                  key={i}
                  src={logo.src}
                  alt={logo.alt}
                  className={`${isLarge ? "h-[44px] sm:h-[52px]" : "h-[28px] sm:h-[32px]"} w-auto object-contain shrink-0`}
                />
              );
            })}
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[#EAEAEA]">
        <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32">
          <h2 className="text-center font-serif text-[clamp(28px,4vw,44px)] md:text-[clamp(36px,5vw,52px)] leading-[1.2] font-medium text-[#111]">
            Built for scale. Trusted globally
          </h2>

          <div className="mt-10 md:mt-14 lg:mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10 xl:gap-12">
            {[
              { value: "42k", label: "Total Downloads", icon: iconDownload },
              { value: "173+", label: "Countries Available", icon: iconWorld },
              { value: "2.13M", label: "Social Interactions", icon: iconHeart },
              { value: "40M", label: "Early Users Reach", icon: iconGroup },
            ].map((stat, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div className="w-[72px] h-[72px] lg:w-[88px] lg:h-[88px] xl:w-[100px] xl:h-[100px] rounded-full bg-[#E8F5EE] flex items-center justify-center shadow-[0_0_0_6px_rgba(232,245,238,0.4)]">
                  <img src={stat.icon} alt="" aria-hidden="true" className="w-[28px] h-[28px] lg:w-[36px] lg:h-[36px] xl:w-[42px] xl:h-[42px]" />
                </div>
                <p className="mt-5 lg:mt-6 text-[32px] lg:text-[40px] xl:text-[48px] font-bold text-[#0B0D0B] leading-none">
                  {stat.value}
                </p>
                <p className="mt-2 text-sm lg:text-base xl:text-lg text-[#6B7280]">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SocialProofSection;
